import {fetchUser, updateUser, updateUserPhoto, deleteUserPhoto} from "../../services/UserService";
import SystemNotificator from "../../services/SystemNotificator";
import i18n from "@/i18n";

export const namespaced = true;

export const state = {
    users: []
};

export const getters = {
    findUser: state => uuid => {
        return state.users.find(el => el.uuid === uuid);
    }
};

export const mutations = {
    ADD_USER_TO_COLLECTION(state, user) {
        // Usuwanie ewentualnie występującego już wpisu
        state.users = state.users.filter(oldUser => oldUser.uuid !== user.uuid);

        // Dodawanie użytkownika do kolekcji
        state.users.push(user);
    },

    /**
     * Aktualizuje własności użytkownika
     *
     * @param state
     * @param email
     * @param data
     * @constructor
     */
    UPDATE_USER(state, {uuid, data}) {
        state.users = state.users.map(user => {
            if (user.uuid === uuid) {
                for (let property of Object.keys(data)) {
                    user[property] = data[property];
                }
            }
            return user;
        });
    }
};

export const actions = {

    fetchUser({commit,getters}, {uuid, force}) {

        // Jeśli użytkownik jest już pobrany, to nie pobiramy go ponownie
        if (getters.findUser(uuid) && !force) {
            return;
        }

        return fetchUser(uuid)
            .then(({data}) => commit('ADD_USER_TO_COLLECTION', data.data))
    },

    updateUser({commit, getters}, {uuid, data}) {

        if (! getters.findUser(uuid)) {
            return Promise.reject({errors: {message: 'Użytkownik nie istnieje'}});
        }

        return updateUser(uuid, data)
            .then(() => {
                commit('UPDATE_USER', {uuid, data});
                SystemNotificator.success({title: '', message: i18n.t('profile.user_has_ben_updated_flash')});
            })
            .catch(() => {
                SystemNotificator.error({title: '', message: i18n.t('profile.user_update_error_flash')});
            })
    },

    updateUserPhoto({commit}, {uuid, photo}) {
        return updateUserPhoto(uuid, photo)
            .then(() => {
                const data = {photoUuid: photo};
                commit('UPDATE_USER', {uuid, data});
                SystemNotificator.success({title: '', message: i18n.t('profile.user_has_ben_updated_flash')});
            })
            .catch(() => {
                SystemNotificator.error({title: '', message: i18n.t('profile.user_update_error_flash')});
            })
    },

    deleteUserPhoto({commit}, {uuid}) {
        return deleteUserPhoto(uuid)
            .then(() => {
                const data = {photoUuid: null};
                commit('UPDATE_USER', {uuid, data});
                SystemNotificator.success({title: '', message: i18n.t('profile.user_has_ben_updated_flash')});
            })
            .catch(() => {
                SystemNotificator.error({title: '', message: i18n.t('profile.user_update_error_flash')});
            })
    },
};